import { useRef } from 'react';
import { post } from './api';
import { useAuth } from './auth';
import { can } from './permissions';

export function PrinterSampleAction({ printer, sample, busy, blocked, online, unavailable, blocker, run, notify }: {
  printer: any; sample?: any; busy: boolean; blocked: boolean; online: boolean; unavailable: boolean; blocker: boolean;
  run: (action: () => Promise<any>) => Promise<unknown>; notify: (message: string) => void;
}) {
  const { user } = useAuth();
  const scope = `${printer.id}:${printer.config_version}:${sample?.id ?? 'new'}`;
  const request = useRef({ scope, key: crypto.randomUUID() });
  if (request.current.scope !== scope) request.current = { scope, key: crypto.randomUUID() };
  const reprint = !!sample && ['SENT_UNVERIFIED', 'OUTPUT_CONFIRMED', 'FAILED', 'EXPIRED'].includes(sample.state);
  const create = !sample || sample.state === 'CANCELLED';
  const processing = !!sample && ['QUEUED', 'LEASED', 'RECEIVED', 'SENDING'].includes(sample.state);
  const permitted = can(user, 'printing.device_test') && (!reprint || can(user, 'printing.reprint'));
  const disabled = busy || blocked || !online || unavailable || blocker || !permitted || (!create && !reprint);
  const label = busy ? 'Đang gửi yêu cầu…' : processing ? (sample.state === 'SENDING' ? 'Đang in nhãn mẫu…' : 'Đang chờ in mẫu…') : reprint ? 'In lại nhãn mẫu' : 'In nhãn mẫu';
  const hint = unavailable ? 'Chưa cập nhật được yêu cầu mới nhất. Bấm Làm mới trước khi in thêm.' :
    blocked ? 'Trạm kết nối hoặc khu vực đang bị khóa.' : !online ? 'Trạm kết nối mất mạng. Kiểm tra nguồn và Wi-Fi trước khi in mẫu.' :
    blocker || sample?.state === 'UNKNOWN' ? 'Cần kiểm tra kết quả nhãn trước. Xử lý tại phần “Kiểm tra nhãn” bên trên rồi mới in thêm.' :
    processing ? 'Yêu cầu mẫu đang được xử lý. Chờ kết quả trước khi gửi thêm nhãn.' :
    !permitted ? 'Bạn chưa có quyền thực hiện lần in này. Nhờ người quản lý in lại nhãn mẫu.' :
    sample?.state === 'SENT_UNVERIFIED' ? 'Lần gửi trước đã kết thúc. Nếu nhãn mờ, lỗi hoặc cần thêm một mẫu, bạn có thể in lại.' :
    reprint ? 'Bạn có thể gửi lại một nhãn mẫu để kiểm tra và xác nhận.' : '';
  return <div className="printer-sample-action">
    {can(user, 'printing.device_test') && <button type="button" className="primary" disabled={disabled} aria-busy={busy} onClick={() => void run(async () => {
      const result = await post(reprint ? `/printing/jobs/${sample.id}/reprint` : `/printing/printers/${printer.id}/test`, reprint
        ? { requestKey: request.current.key, reason: 'Người dùng chọn in lại nhãn mẫu để kiểm tra giấy và QR' }
        : { raster: true, requestKey: request.current.key }, { feedback: false });
      notify(result.existing ? 'Đã có yêu cầu in mẫu này. Đang mở lại để theo dõi, không gửi trùng.' : 'Đã gửi yêu cầu in mẫu. Chờ giấy ra rồi quét mã để xác nhận ngay bên dưới.');
    })}>{label}</button>}
    {hint && <p role="status">{hint}</p>}
  </div>;
}
